import {
    HelpTopic,
    SaveMode,
    SubmitHelpTopicFormRequest,
    SubmitHelpTopicFormResponse,
} from "src/api/Tmd.dtos";
import useBaseFormSubmit from "../useBaseFormSubmit";

const useHelpTopicFormSubmit = (): ((
    model: HelpTopic,
    mode: SaveMode,
) => Promise<SubmitHelpTopicFormResponse>) =>
    useBaseFormSubmit<
        HelpTopic,
        SubmitHelpTopicFormResponse,
        SubmitHelpTopicFormRequest
    >(SubmitHelpTopicFormRequest);

export default useHelpTopicFormSubmit;
